<template>
  <div>
    <div class="card">
        <div class="card-content">
                <h4 class="card-title">Bitácora de consultas Balanza</h4>
                <div class="row">
                     <div class="col-md-5">
                        <label class="control-label">
                            Desde
                        </label>
                        <div class="form-group">
                        <el-date-picker 
                            name="fecha_inicio"
                            v-model="model.fecha_inicio" 
                            format="dd-MM-yyyy" value-format="yyyy-MM-dd"
                            type="date" 
                            placeholder="Elige un día">
                        </el-date-picker>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <label class="control-label">
                            Hasta
                        </label>
                        <div class="form-group">
                        <el-date-picker 
                            name="fecha_fin"
                            v-model="model.fecha_fin" 
                            format="dd-MM-yyyy" value-format="yyyy-MM-dd"
                            type="date" 
                            placeholder="Elige un día">
                        </el-date-picker>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <br>
                        <button @click="getBitacora" class="btn btn-fill btn-success">
                                Buscar
                        </button>
                    </div>
                </div>
                <br>
                
                <br><br><br>          

<!--             <div>
                <br>
                <div class="offset-md-6 col-sm-6 col-md-6 col-lg-6">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <b-input-group>
                    <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
                <div class="row mt-3 mb-4">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <b-table id="tbl_movimientos" responsive hover :items="list_bitacora" :fields="fields_list" :per-page="perPage" :current-page="currentPage" show-empty :filter="filter" @filtered="onFiltered">
                  
                    <template slot="acciones" slot-scope="row" class="actions">
                        <b-button :id="'d'+row.item.id" variant="success" size="sm" @click.prevent="descargar(row.item)" class="edit mr-2" >
                        <i class="ti-download"></i>
                        </b-button>
                        <b-tooltip :target="'d'+row.item.id" title="Descargar Declaración"></b-tooltip>
                        <b-button :id="'r'+row.item.id" variant="danger" size="sm" @click.prevent="reactivar(row.item)" class="edit mr-2" >
                        <i class="ti-unlock"></i>
                        </b-button>
                        <b-tooltip :target="'r'+row.item.id"  title="Reactivar declaración"></b-tooltip>
                    </template>
                    <template slot="empty">
                        <h5>No existen registros</h5>
                    </template>
                    <template slot="id" slot-scope="row" v-show="false">{{row.item.id}}</template>
                    <template slot="rfc" slot-scope="row">{{row.item.rfc}}</template>
                    <template slot="nombres" slot-scope="row">{{row.item.nombres}}</template>
                    </b-table>
                </div>
                
                <div class="col-mb-8 col-8">
                    <b-col md="6" class="my-1">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" first-text="<<" prev-text="<" next-text=">" last-text=">>" aria-controls="tbl_movimientos"></b-pagination>
                    </b-col>
                </div>
                <div class="col-mb-12 col-12">
                    <p class="category">Mostrando <b>{{from + 1}}</b> a <b>{{to}}</b> de <b>{{total}}</b> registros</p>
                </div>
                </div>
            </div> -->

                    <div>
          <br>
          <div class="offset-md-6 col-sm-6 col-md-6 col-lg-6">
            <b-form-group label-cols-sm="3" class="mb-0">
              <b-input-group>
                <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row mt-3 mb-4">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <!-- <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details>
            </v-text-field> -->
              <v-data-table :headers="fields_list" :items="list_bitacora" :items-per-page="5" :search="filter" class="" :fixed-header="true">
                <template v-slot:item.acciones="{ item }">
                   <b-button :id="'d'+item.id" variant="success" size="sm" @click.prevent="descargar(item)" class="edit mr-2" >
                        <i class="ti-download"></i>
                    </b-button>
                        <b-tooltip :target="'d'+item.id" title="Descargar Declaración"></b-tooltip>
                    <b-button :id="'r'+item.id" variant="danger" size="sm" @click.prevent="reactivar(item)" class="edit mr-2" >
                        <i class="ti-unlock"></i>
                        </b-button>
                    <b-tooltip :target="'r'+item.id"  title="Reactivar declaración"></b-tooltip>
                </template>
                <template v-slot:item.fecha_declaracion="{ item }">
                  <div>{{dateFormat(item.fecha_declaracion)}}</div>
                </template>
                <template v-slot:item.fecha="{ item }">
                  <div>{{dateFormat(item.fecha)}}</div>
                </template>
              </v-data-table>

             
            </div>

        
          </div>
        </div>


        </div>
    </div>
    
 </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option, DatePicker} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import moment from 'moment'


/*   Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
 */

  export default {
    components: {
      PPagination,
      [Table.name]:Table,
      [TableColumn.name]:TableColumn,
      [Select.name]:Select,
      [Option.name]:Option,
      [DatePicker.name]: DatePicker,
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {
        model:{tipo_declaracion:'',dependencia_id:'',periodo:''},
        dependencias:{},
        rol:'',
        filter:null,
        currentPage: 1,
        perPage: 50,
        periodos:[],
        model:{},
        rows:null,
        tiposDeclaracion:[],
        list_bitacora:[],

        filtro_usuarios: [],
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        fields_list: [{
                        text: 'RFC',
                        align: 'center',
                        sortable: false,
                        value: 'rfc',
                        class: 'text-center td-small'
                    },
                    {
                        text: 'Nombres',
                        align: 'center',
                        sortable: false,
                        value: 'nombres',
                        class: 'text-center td-small'
                    },{
                        text: 'Dependencia',
                        align: 'center',
                        sortable: false,
                        value: 'dependencia',
                        class: 'text-center td-small'
                    },{
                        text: 'Tipo de Declaración consultada',
                        align: 'center',
                        sortable: false,
                        value: 'tipo_declaracion',
                        class: 'text-center td-small'
                    },
                    {
                        text: 'Fecha de Declaración consultada',
                        align: 'center',
                        sortable: false,
                        value: 'fecha_declaracion',
                        class: 'text-center td-small'
                      
                    },
                    {
                        text: 'Usuario',
                        align: 'center',
                        sortable: false,
                        value: 'usuario',
                        class: 'text-center td-small'
                    },
                    {
                       text: 'Consulta',
                        align: 'center',
                        sortable: false,
                        value: 'fecha',
                        class: 'text-center td-small'
                    },]
    }},    
    computed: {
      pagedData () {
        return this.list_bitacora.slice(this.from, this.to)
      },
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.list_bitacora.length
          return this.pagedData
        }
        let result = this.list_bitacora
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to() {
        let highBound = this.from + this.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      total() {
        //console.log(this.list_bitacora.length);
        this.rows = this.list_bitacora.length;

        return this.list_bitacora.length;
      }
    },
    watch: {
    '$route': 'checkPermissions'
    },
    methods:{  
          
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.rows = filteredItems.length
        this.currentPage = 1
      },
        checkPermissions() {
            let permiso = [1];
            if(!this.getKey('permisos').some(r=> permiso.includes(r)))
            {
                 localStorage.clear();                                             
                 this.$router.push('/login'); 
                 this.$router.go();
       
            }
        },
        getBitacora(){ 

        this.$http.get("bitacorab/"+this.model.fecha_inicio +'/'+this.model.fecha_fin).then(
        response => {
                var v = this;  
                v.list_bitacora = [];
                $.each(response.data.bitacora, function(key, value) {
                v.list_bitacora.push({  'rfc':      value.declarante.rfc,
                                        'nombres':  value.declarante.nombres+' '+value.declarante.primer_apellido+' '+value.declarante.segundo_apellido,
                                        'dependencia':value.declarante.encargo.ente.valor,
                                        'usuario': value.usuario.Nombre+' '+value.usuario.Paterno+' '+value.usuario.Materno,
                                        'fecha': value.created_at, 
                                        //'tipo_declaracion': (typeof value.declaracion.Tipo_Dec != 'undefined') ? value.declaracion.Tipo_Dec : '',
                                        //'fecha_declaracion':value.declaracion.Fecha_Dec
                                        });                 
                });    
                
            },
            error => {
            this.StepError(error);
            }
        );
            

            
        },
        dateFormat: function (date) {
        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
        }
    },
    created(){
        this.rol = this.getKey('role'); 
        this.checkPermissions()
    }
  }

</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/BitacoraB.vue